import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VesselEditComponent } from './vessel-edit.component';
import { VesselEditResolve } from './vessel-edit.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/boatyard/vessel/:id',
        component: VesselEditComponent,
        resolve: {
          portal: VesselEditResolve,
        },
      },
      {
        path: 'manage/admin/vessel/:id',
        component: VesselEditComponent,
        resolve: {
          portal: VesselEditResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class VesselEditRoutingModule {}
